import { render, staticRenderFns } from "./DiagramEdit.vue?vue&type=template&id=1cb2ca40&"
import script from "./DiagramEdit.vue?vue&type=script&lang=js&"
export * from "./DiagramEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports